import { PARTNER360_NAMESPACE } from '../common/constants'

export const PARTNER360_SHARE_OF_BUSINESS_NAMESPACE = `${PARTNER360_NAMESPACE}/shareOfBusiness`

// Async thunk constants
export const REQUEST_PARTNER360_UPDATE_PARTNER_DEVICES_INFO = `${PARTNER360_SHARE_OF_BUSINESS_NAMESPACE}/updateDevicesInfo`
export const REQUEST_PARTNER360_UPDATE_PARTNER_BASE_METRICS = `${PARTNER360_SHARE_OF_BUSINESS_NAMESPACE}/updatePartnerBaseMetrics`
export const REQUEST_PARTNER360_UPDATE_TOP_VENDOR_BRANDS = `${PARTNER360_SHARE_OF_BUSINESS_NAMESPACE}/updateTopVendorBrands`
